// @flow
import React from 'react'

export type TextAreaProps = {}

export default function TextArea(props: TextAreaProps): * {
  return <textarea {...props} />
}
